import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import {closeDrawer} from "../../actions/drawerActions";
import GroupEditor from "../qd/groups/GroupEditorHook";
import {createGroupTemplateAndCloseDrawer, saveGroupTemplateAndCloseDrawer} from "../../actions/groupTemplateActions";
import * as TEMPLATE from "../../constants/templateConstants";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import {createEditorOrigin, EDITOR_TYPES} from "../../utilities/editorInstanceOwnership";

const GroupCreateEditDrawer = ({ 
    createMode = false,
    templateKey = "",
    templateId = null,
    templateMode = "",
    setLoadingState,
    filter
}) => {
    const dispatch = useDispatch();
    const versionsFilter = useSelector(state => state.filter[TEMPLATE.FILTER.current.group]);
    const versionsFilterState = useSelector(state => state.filter[TEMPLATE.FILTER.versions.group]);
    const drawerStack = useSelector(state => state.drawerStack)
    const editorInstanceId = useSelector(state => state.groupEditor.instanceId);

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const onCreateSuccess = () => {
        // Navigation handled by withRouter in parent component
    };

    const save = (groupTemplate) => {
        const requestOwner = createEditorOrigin(EDITOR_TYPES.GROUP, editorInstanceId);
        if (createMode) {
            return dispatch(createGroupTemplateAndCloseDrawer(
                groupTemplate,
                versionsFilter,
                onCreateSuccess,
                requestOwner
            ));
        }
        return dispatch(saveGroupTemplateAndCloseDrawer(
            groupTemplate,
            filter,
            versionsFilter,
            templateMode,
            versionsFilterState,
            requestOwner
        ));
    };

    const handleRequestSave = (groupTemplate) => {
        if ((typeof setLoadingState === "function") && (templateMode !== "versions")) {
            return setLoadingState(save, groupTemplate);
        }
        return save(groupTemplate);
    };

    return (
        <div id="GroupCreateEditDrawer-container-div" style={{height: "100%"}}>
            <ArgoAppBarHook
                title={drawerStack.displayTitle}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={groupCreateEditDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <GroupEditor
                createMode={createMode}
                cancel={handleCloseDrawer}
                save={handleRequestSave}
                templateKey={templateKey}
                templateId={templateId}
                templateMode={templateMode}
                width={groupCreateEditDrawerProps.width}
                scrollTo="GroupCreateEditDrawer-container-div"
            />
        </div>
    );
};

// <GroupEditor cancel={this.close} save={this.handleRequestSave.bind(this)} templateKey={this.props.templateKey} templateId={this.props.templateId} editMode={true}/>

GroupCreateEditDrawer.defaultProps = {
    createMode: false,
    templateKey: "",
    templateId: null,
    templateMode: ""
};

GroupCreateEditDrawer.propTypes = {
    createMode: PropTypes.bool,
    setLoadingState: PropTypes.func,
    templateKey: PropTypes.string,
    templateId: PropTypes.number,
    templateMode: PropTypes.string,
    filter: PropTypes.object,
};

const groupCreateEditDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default GroupCreateEditDrawer;
export {groupCreateEditDrawerProps};
